import script from "./PersonalCalendarComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalCalendarComponent.vue?vue&type=script&setup=true&lang=js"

import "./PersonalCalendarComponent.vue?vue&type=style&index=0&id=2aedc190&lang=scss"

const __exports__ = script;

export default __exports__